import accountContext from '../account/accountContext';
import { store } from './store';
import { refreshAccount } from '../account/accountSlice';
import { buildAccountSignInWithReturn } from '../account/routes';
import { showAccessDenied } from '../public/accessDeniedSlice';

export interface ErrorHandlerCallbacks {
  onAccessDenied?: () => void;
}

let callbacks: ErrorHandlerCallbacks = {};

export const setErrorHandlerCallbacks = (newCallbacks: ErrorHandlerCallbacks) => {
  callbacks = newCallbacks;
};

export const handle403Error = (responseData?: any) => {
  const currentPath = window.location.pathname;

  if (currentPath.includes('/public/')) {
    const fullUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;

    accountContext.logout();
    store.dispatch(refreshAccount(null));

    window.location.href = buildAccountSignInWithReturn(fullUrl);

    if (callbacks.onAccessDenied) {
      callbacks.onAccessDenied();
    }
  } else {
    // Authenticated user received 403 - show permission denied toast
    const denialType = responseData?.details?.type as 'role' | 'module' | undefined;
    store.dispatch(showAccessDenied(denialType));
  }
};
